export const TopbarLogo = () => (
  <img
    src="/images/frida-logo.svg"
    alt="Frida Logo"
    className="h-7 text-black"
    style={{ width: 74 }}
  />
);
